import Phaser from 'phaser';

import { GameSizeMetrics } from 'src/games/common/phaser/game/scenes/scaled-base-scene';
import { BlocksMainScene } from '../../scenes/blocks-main-scene';
import { ShapeBoardViewModel } from './shape-board-view-model';
import { Subscription } from 'rxjs';
import { ShapeView } from './shape-view';
//import { DebugContainerVisual } from '../debug/debug-container-visual';

export class ShapeBoardView extends Phaser.GameObjects.Container {
  private subscriptionGroup: Subscription;
  private backgroundRectangle: Phaser.GameObjects.Rectangle;
  private shapeViews: ShapeView[] = [];

  //private debugContainerVisual: DebugContainerVisual;

  constructor(
    scene: BlocksMainScene,
    x: number,
    y: number,
    private viewModel: ShapeBoardViewModel,
  ) {
    super(scene, x, y);

    //this.debugContainerVisual = new DebugContainerVisual(scene, this);

    this.subscriptionGroup = new Subscription();

    this.backgroundRectangle = scene.add.rectangle(0, 0, 0, 0, 0x002200);
    this.backgroundRectangle.alpha = 0.0;
    this.add([this.backgroundRectangle]);

    this.setName(ShapeBoardView.name);
    scene.add.existing(this);

    this.subscriptionGroup.add(
      this.viewModel.onResetGameScene$.subscribe(() => {
        this.shapeViews.forEach((view) => {
          view.destroy();
        });
        this.shapeViews.length = 0;
      }),
    );
    this.subscriptionGroup.add(
      viewModel.blocksLogicActionBus$.subscribe((actionBus) => {
        if (!actionBus) {
          return;
        }
        actionBus.on('onNextThreeShapes', () => {
          if (viewModel.spawnShapes()) {
            this.shapeViews = viewModel.allShapeViewModels.map(
              (vm) => new ShapeView(scene, 0, 0, vm),
            );
          }
          this.shapeViews.forEach((view, index) => {
            view.onResize(scene.currentGameSizeMetrics);
            view.animateIn(index * 100);
          });
        });
        actionBus.on('onShapeRemoved', (payload) => {
          const index = this.shapeViews.findIndex((item) => item.shapeId === payload.shapeId);
          if (index !== -1) {
            const [item] = this.shapeViews.splice(index, 1);
            item.destroy();
          }
          viewModel.destroyShape(payload.shapeId);
        });
        actionBus.on('onRemainingShapesCanBePlaced', (payload) => {
          viewModel.refreshRemainingShapes(payload.validShapes);
        });
      }),
    );
  }

  override destroy(_fromScene?: boolean | undefined): void {
    this.subscriptionGroup.unsubscribe();

    super.destroy(_fromScene);
  }

  public sceneUpdate(time: number, delta: number) {
    this.shapeViews.forEach((view) => {
      view.sceneUpdate(time, delta);
    });
  }

  public onResize(gameSizeMetrics: GameSizeMetrics) {
    this.shapeViews.forEach((view) => view.onResize(gameSizeMetrics));

    this.resizeShapeBoard(gameSizeMetrics);
  }

  private resizeShapeBoard(gameSizeMetrics: GameSizeMetrics) {
    const layoutConfig = this.viewModel.layoutConfig;
    const calc = this.viewModel.calculateScaleFactor(gameSizeMetrics);

    const cellSz = layoutConfig.boardHeight / 9;
    const shapeBoardHeight = cellSz * 3;

    const xPos = layoutConfig.hMargin + layoutConfig.boardWidth * 0.5;
    const yPos = layoutConfig.vMargin + shapeBoardHeight * 0.5 + layoutConfig.boardHeight;

    this.backgroundRectangle.setSize(
      layoutConfig.boardWidth * calc.scaleFactor,
      shapeBoardHeight * calc.scaleFactor,
    );

    this.setPosition(xPos * calc.scaleFactor + calc.scaledOffsetX, yPos * calc.scaleFactor);
    this.setSize(layoutConfig.boardWidth * calc.scaleFactor, shapeBoardHeight * calc.scaleFactor);
  }
}
